import {ReactElement, useState} from "react";
import Container from "@mui/material/Container";
import Toolbar from "@mui/material/Toolbar";
import Grid from "@mui/material/Grid";
import Title from "../../components/Title";
import {PageDto} from "../../domain/PageDto";
import {SearchDataFunction} from "../../components/types/SearchDataFunction";
import {useSearchAuditEvents} from "../../application/AuditService";
import {AuditEvent} from "../../domain/audit/AuditEvent";
import {AuditEventSearchTerm} from "../../domain/audit/AuditEventSearchTerm";
import AuditEventComponent from "../../components/AuditEventComponent";
import AuditEventSearchBar, {AuditEventSearchFields} from "./AuditEventSearchBar";
import {Collapse} from "@mui/material";

export default function AuditEventsPage(): ReactElement {
    const searchFn: SearchDataFunction<AuditEventSearchTerm, PageDto<AuditEvent>> = useSearchAuditEvents(null);
    const [ searchExpanded, setSearchExpanded ] = useState<boolean>(false);

    return (
        <Container maxWidth={ false } sx={{ mt: 4, mb: 4 }}>
            { <Toolbar/> }
            <Grid
                container
                spacing={2}
                sx={{
                    alignItems: "center",
                    justifyContent: "space-between",
                    mb: 2
                }}>
                <Grid size={{ xs: 12, md: 11, lg: 11 }}>
                    <Title>Audit Events</Title>
                </Grid>
                <AuditEventSearchBar searchFn={ searchFn } expanded={searchExpanded} onToggle={setSearchExpanded}/>
            </Grid>
            <Collapse in={searchExpanded} timeout="auto" unmountOnExit>
                <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid size={{ xs: 12, md: 12, lg: 12 }}>
                        <AuditEventSearchFields searchFn={ searchFn }/>
                    </Grid>
                </Grid>
            </Collapse>
            <Grid container spacing={2}>
                <AuditEventComponent data={ searchFn.data.data } loading={searchFn.loading}/>
            </Grid>
        </Container>
    );
}